import { render, staticRenderFns } from "./FamilyCategoryDialog.vue?vue&type=template&id=6e4bee5c&"
import script from "./FamilyCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./FamilyCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports